import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

// the backend's AuthSubscriber answers an expired session with {error: 'Not logged in'}
const isSessionError = (message) => typeof message === 'string' && message.toLowerCase() === 'not logged in';

// kind 'action': a languages request failed after the app had loaded
export default function AppLoadError({ message, kind }) {
  const { t } = useTranslation();
  const sessionExpired = isSessionError(message);
  const variant = sessionExpired ? 'sessionExpired' : kind === 'action' ? 'languagesAction' : null;
  const title = t(variant ? `appError.${variant}Title` : 'appError.title');
  const description = t(variant ? `appError.${variant}Description` : 'appError.description');

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2, bgcolor: 'background.default' }}>
      <Paper sx={{ p: 3, maxWidth: 480, width: '100%' }}>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {description}
        </Typography>
        {message && !sessionExpired &&
          <Typography variant="caption" component="p" color="text.secondary" sx={{ mt: 1, wordBreak: 'break-word' }}>
            {message}
          </Typography>
        }
        <Button variant="contained" sx={{ mt: 2 }} onClick={() => window.location.reload()}>
          {t('appError.reload')}
        </Button>
      </Paper>
    </Box>
  );
}
